<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">
      <div class="row">




      </div>

      <section id="file-export">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">File export</h4>
                <br>

                <div class="row">
                  <div class="form-group data-custon-pick data-custom-mg data_5">
                    <div class="input-daterange input-group" id="datepicker">
                      <div id="FileDiv" class="input-daterange input-group">


                        <span class="input-group-text" id="basic-addon3"><i class="ft-zap"></i></span>
                        <select #selectedDevice (change)="selectChangeHandler($event)" class="browser-default custom-select">
                          <option selected>Select Device</option>
                          <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}</option>

                        </select>


                        <span class="input-group-text" id="basic-addon3">From</span>
                        <input type='date' #fromDate class="form-control " placeholder="Date of birth" />


                        <span class="input-group-text" id="basic-addon3">To</span>
                        <input type='date' #ToDate ngModel="ToDate" class="form-control " placeholder="Date of birth" />

                        <input type='button' (click)="GetAllLogs(selectedDevice.value,fromDate.value,ToDate.value)" class="btn btn-primary" value="Get All Logs" />



                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div  class="card-content ">
                <div class="card-body card-dashboard table-responsive">

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
